import { BenefitTemplateDTO, BenefitTemplateItemDTO, TenantDTO } from 'probonio-shared-ui/api';
import { useCallback } from 'react';
import { BenefitActivationDialogExtensionInterface } from '../../../extension/interface/benefit-activation-dialog.extension.interface';
import { getExtensionForBenefit } from '../../benefits';
import { useOrderedBenefits } from '../../benefits/useOrderedBenefits';

export function useTemplateValid(tenant: TenantDTO | undefined) {
  const { activeBenefits } = useOrderedBenefits(tenant);

  const isTemplateItemValid = useCallback(
    (templateItem: BenefitTemplateItemDTO) => {
      if (!activeBenefits.includes(templateItem.benefit)) {
        return false;
      }
      const extension = getExtensionForBenefit(templateItem.benefit, BenefitActivationDialogExtensionInterface);
      return extension?.isPreconditionMet?.(tenant) ?? true;
    },
    [activeBenefits, tenant],
  );
  const isTemplateValid = useCallback(
    (template: BenefitTemplateDTO) => {
      return template.templateItems.every(item => isTemplateItemValid(item));
    },
    [isTemplateItemValid],
  );

  return { isTemplateItemValid, isTemplateValid };
}
